import * as React from 'react';
import classNames from 'classnames';
import { useWasSeenByUser } from '@grandvisionhq/analytics';
import { pushPromotionClick, pushPromotionImpression } from '../../utils/data-layer.js';
import { BannerRecommendation } from './components/BannerRecommendation.js';

const BannerRecommendationBlock = ({ recommendation , shouldRenderAsCard , className , tabIndex ,  })=>{
    const clickRef = React.useRef(false);
    const { ref , wasSeen  } = useWasSeenByUser();
    const handlePromotionClick = React.useCallback(()=>{
        if (!clickRef.current) {
            clickRef.current = true;
            pushPromotionClick(recommendation);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    React.useEffect(()=>{
        if (wasSeen) {
            pushPromotionImpression(recommendation);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        wasSeen
    ]);
    return /*#__PURE__*/ React.createElement(BannerRecommendation, {
        ref: ref,
        onClick: handlePromotionClick,
        recommendation: recommendation,
        className: classNames(className, 'banner-recommendation-block', {
            'banner-recommendation-block--card': shouldRenderAsCard
        }),
        tabIndex: tabIndex
    });
};

export { BannerRecommendationBlock };
//# sourceMappingURL=BannerRecommendationBlock.js.map
